// Purpose: Service for handling socket.io connections.
import { Injectable, inject, NgZone } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { SocketIo } from './socket-io.class';
import type { SocketIoConfig } from './socket-io.model';
import { SOCKET_CONFIG_TOKEN } from './socket-io.token';

@Injectable()
export class SocketIoService {
  private readonly config = inject<SocketIoConfig>(SOCKET_CONFIG_TOKEN);
  private authService = inject(AuthService);
  private ngZone = inject(NgZone);

  /** Creates a new socket connection */
  createSocket() {
    return new SocketIo(
      {
        ...this.config,
        options: {
          ...this.config.options,
          auth: (cb) => {
            this.authService.getAccessToken().then((token) => cb({ token, type: 'jwt' }));
          },
        },
      },
      this.ngZone
    );
  }
}
